import { useFieldArray, useFormContext } from "react-hook-form";

import {
  Button,
  InputText,
  SectionHeader,
  TableData,
  TableRow,
  TableSecondary,
  Text,
} from "@pentabd/ui";
import { IconPlus, IconSearch } from "@pentabd/icons";
import { InputFile, SelectController } from "@components";

import { FORM_FIELDS } from "@constants/form";
import { getTenderInfo } from "@helpers/getTenderInfo";
import { useTranslation } from "react-i18next";
import { useTenderOpening } from "@hooks/procurements/procurement/useTenderOpening";

const TENDER_EVOLUTION = FORM_FIELDS.PROCUREMENT_DETAILS.TENDER_EVOLUTION;

const COLUMNS = (t: any) => [
  {
    id: 1,
    name: t("PROCUREMENT_CREATE.TENDER_EVOLUTION.TABLE.NAME"),
    key: "name",
  },
  {
    id: 2,
    name: t("PROCUREMENT_CREATE.TENDER_EVOLUTION.TABLE.PROPOSED_PRICE"),
    key: "price",
  },
  {
    id: 3,
    name: t("PROCUREMENT_CREATE.TENDER_EVOLUTION.TABLE.STATUS"),
  },
  {
    id: 4,
    name: t("PROCUREMENT_CREATE.TENDER_EVOLUTION.TABLE.REMARKS"),
  },
];

const evaluationVendors = [
  {
    id: 1,
    name: "Vendor 1",
    price: 120,
  },
  {
    id: 2,
    name: "Vendor 2",
    price: 50,
  },
  {
    id: 3,
    name: "Vendor 3",
    price: 30,
  },
];

const STATUS = [
  {
    label: "Responsive",
    value: "RESPONSIVE",
  },
  {
    label: "Non-Responsive",
    value: "NON_RESPONSIVE",
  },
];
export default function VendorList({
  id,
  vendors,
}: {
  id: string | undefined;
  vendors: any[];
}) {
  const { t } = useTranslation();
  const { getSingleData } = useTenderOpening(id as string);

  const {
    register,
    setValue,
    control,
    formState: { errors },
    getValues,
  } = useFormContext();
  const {} = useFieldArray({
    control,
    name: "evaluationVendors",
  });
  return (
    <div className="pt-10">
      <SectionHeader
        title={t("PROCUREMENT_CREATE.TENDER_EVOLUTION.VENDOR_LIST")}
      />
      <div className="pt-10">
        <TableSecondary columns={COLUMNS(t)}>
          {vendors?.map(
            (
              {
                id,
                vendorName,
                proposedPrice,
                vendorId,
              }: {
                id: number;
                vendorName: string;
                proposedPrice: number;
                vendorId: number;
              },
              index: number,
            ) => {
              // setValue(
              //   `evaluationVendors.${index}.${TENDER_EVOLUTION.VENDOR_NAME}`,
              //   name,
              // );
              setValue(
                `evaluationVendors.${index}.${TENDER_EVOLUTION.PROPOSED_PRICE}`,
                proposedPrice,
              );
              setValue(`evaluationVendors.${index}.vendorId`, vendorId);
              return (
                <TableRow key={id}>
                  <TableData>
                    <Text className="text-subtitle1 text-nowrap">
                      {vendorName}
                    </Text>
                  </TableData>
                  <TableData>
                    <Text className="text-subtitle1 text-nowrap">
                      {proposedPrice}
                    </Text>
                  </TableData>

                  <TableData>
                    <SelectController
                      options={STATUS}
                      name={`evaluationVendors.${index}.${TENDER_EVOLUTION.STATUS}`}
                      control={control}
                      setValue={setValue}
                      register={{
                        ...register(
                          `evaluationVendors.${index}.${TENDER_EVOLUTION.STATUS}`,
                          {
                            required: "Status is required",
                          },
                        ),
                      }}
                      portal
                      error={errors as any}
                      selectAction={(e) => {
                        const { proposedPrice, vendorId, vendorName } =
                          getTenderInfo(getValues().evaluationVendors);

                        setValue(
                          TENDER_EVOLUTION.SELECTED_VENDOR_FOR_NOA,
                          vendorId,
                        );

                        setValue(
                          TENDER_EVOLUTION.SELECT_VENDOR_FOR_NOA,
                          `${vendorName || "Name"} - ${
                            proposedPrice || "Price"
                          }`,
                        );
                      }}
                    />
                  </TableData>

                  <TableData>
                    <InputText
                      {...register(
                        `evaluationVendors.${index}.${TENDER_EVOLUTION.REMARKS}`,
                        {
                          required: "Remarks is required",
                        },
                      )}
                      error={errors as any}
                    />
                  </TableData>
                </TableRow>
              );
            },
          )}
        </TableSecondary>
      </div>
    </div>
  );
}
